import React, { Component, Fragment } from "react";
import ReactTable from "react-table";
// import "../../exame/onlineExame/allExam/node_modules/react-table/react-table.css";
// import { ToastContainer, toast } from "react-toastify";
// import "../../exam-practice/createNewMember/node_modules/react-toastify/dist/ReactToastify.css";
// import ProductionService from "../../../services/productionService";
import ProductInfo from "../../creactEditeProduct/productForm";
import MultiplePicture from "./multipalImage";
import moment from "moment";
import { Switch } from "antd";
import "react-table/react-table.css";

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
const formatTime = (date) => {
  date = moment(date).format("MMMM Do / YYYY, hh:mm A").split("/");
  return (
    <div>
      <p style={{ margin: 1 }}>{date[0]}</p>
      <p style={{ margin: 1 }}>{date[1]}</p>
    </div>
  );
};
export class Datatable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedValues: [],
      myData: [],
      modalDelete: false,
    };
  }
  componentDidMount() {
    this.setState({
      checkedValues: [],
      myData: this.props.myData,
      modalDelete: false,
    });
  }

  selectRow = (e, i) => {
    if (!e.target.checked) {
      this.setState({
        checkedValues: this.state.checkedValues.filter((item, j) => i !== item),
      });
    } else {
      this.state.checkedValues.push(i);
      this.setState({
        checkedValues: this.state.checkedValues,
      });
    }
  };

  handleRemoveRow = () => {
    const { removeScanedEmail } = this.props;
    this.setState({ modalDelete: false });
    removeScanedEmail(this.state.checkedValues);
  };

  renderEditable = (cellInfo) => {
    return (
      <div
        style={{ backgroundColor: "#fafafa" }}
        contentEditable
        suppressContentEditableWarning
        onBlur={(e) => {
          const data = [...this.props.myData];
          data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
          // this.setState({ myData: data });
        }}
        dangerouslySetInnerHTML={{
          __html: this.props.myData[cellInfo.index][cellInfo.column.id],
        }}
      />
    );
  };

  Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  render() {
    const {
      loader,
      selectedIndex,
      loading,
      pageSize,
      page,
      totalRecords,
      myClass,
      multiSelectOption,
      pagination,
      onChangePageSize,
      onChangePage,
      myData,
      productStatus,
      onEditBrandInfo,
      onChangeActive,
      brandsList,
      categoryList,
    } = this.props;
    //sTitle
    const columns = [
      // {
      //   Header: (
      //     <h6
      //       style={{
      //         fontWeight: 600,
      //         margin: 0,
      //         letterSpacing: "0px",
      //       }}
      //     >
      //       Product Title
      //     </h6>
      //   ),
      //   accessor: "sTitle",
      //   Cell: null,
      //   style: {
      //     textAlign: "center",
      //   },
      // },
      {
        Header: (
          <h6
            style={{
              fontWeight: 600,
              margin: 0,
              letterSpacing: "0px",
              padding: "15px 10px"
            }}
          >
            Product Name
          </h6>
        ),
        accessor: "name",
        Cell: null,
        style: {
          display:"flex",
          justifyContent:"center",
          alignItems:"center",
          whiteSpace:"nowrap",
          textOverflow:"ellipsis"
          // textAlign: "center",
        },
      },
      {
        Header: (
          <h6
            style={{
              fontWeight: 600,
              margin: 0,
              letterSpacing: "0px",
              padding: "15px 10px"
            }}
          >
            Product Model
          </h6>
        ),
        accessor: "model",
        Cell: null,
        style: {
           display:"flex",
          justifyContent:"center",
          alignItems:"center",
        },
      },
      {
        Header: (
          <h6
            style={{
              fontWeight: 600,
              margin: 0,
              letterSpacing: "0px",
              padding: "15px 10px"
            }}
          >
            Product Brand
          </h6>
        ),
        accessor: "brandId.name",
        Cell: null,
        style: {
           display:"flex",
          justifyContent:"center",
          alignItems:"center",
        },
      },
      {
        Header: (
          <h6
            style={{
              fontWeight: 600,
              margin: 0,
              letterSpacing: "0px",
              padding: "15px 10px"
            }}
          >
            Product Category
          </h6>
        ),
        accessor: "categoryId.name",
        Cell: null,
        style: {
           display:"flex",
          justifyContent:"center",
          alignItems:"center",
        },
      },
      // {
      //   Header: (
      //     <h6
      //       style={{
      //         fontWeight: 600,
      //         margin: 0,
      //         letterSpacing: "0px",
      //       }}
      //     >
      //       In Stock
      //     </h6>
      //   ),
      //   accessor: "quality",
      //   Cell: null,
      //   style: {
      //     textAlign: "center",
      //   },
      // },
      // {
      //   Header: (
      //     <h6
      //       style={{
      //         fontWeight: 600,
      //         margin: 0,
      //         letterSpacing: "0px",
      //       }}
      //     >
      //       Url
      //     </h6>
      //   ),
      //   accessor: "sUrl",
      //   Cell: null,
      //   style: {
      //     textAlign: "center",
      //   },
      // },
      {
        Header: (
          <h6
            style={{
              fontWeight: 600,
              margin: 0,
              letterSpacing: "0px",
            }}
          >
            Date
          </h6>
        ),
        accessor: "createdAt",
        Cell: ({ value }) => {
          return <div>{formatTime(value)}</div>;
        },

        heigth: 40,
        style: {
          textAlign: "center",
        },
      },
      // {
      //   Header: (
      //     <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px" }}>
      //       Short Description
      //     </h6>
      //   ),
      //   accessor: "shortDescription",
      //   width: 200,
      //   Cell: ({ value }) => {
      //     return (
      //       <div
      //         style={{
      //           whiteSpace: "normal",
      //           textAlign: "justify",
      //         }}
      //       >
      //         {value}
      //       </div>
      //     );
      //   },
      //   style: {
      //     textAlign: "center",
      //   },
      // },
      {
        Header: (
          <h6
            style={{
              fontWeight: 600,
              margin: 0,
              letterSpacing: "0px",
              padding: "15px 10px"
            }}
          >
            Status
          </h6>
        ),
        accessor: "public",
        width: 100,
        Cell: ({ value, original, index }) => {
          console.log(index, !value, "original._id, !value");
          return (
            <div style={{}}>
              <Switch
                loading={selectedIndex === index && loader ? true : false}
                defaultChecked={value}
                onChange={() => onChangeActive(original._id, !value, index)}
              />
              {/* {value ? (
                <p
                  style={{
                    background: "green",
                    borderRadius: "25px",
                    color: "#ffffff",
                    fontWeight: 600,
                  }}
                >
                  {"Activated"}
                </p>
              ) : (
                <p
                  style={{
                    background: "red",
                    borderRadius: "25px",
                    color: "#ffffff",
                    fontWeight: 600,
                  }}
                >
                  {"Deactivated"}
                </p>
              )} */}
            </div>
          );
        },
        style: {
           display:"flex",
          justifyContent:"center",
          alignItems:"center",
        },
      },
    ];
    columns.push({
      Header: (
        <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px", padding: "15px 10px" }}>
          Action
        </h6>
      ),
      id: "delete",
      width: 100,
      accessor: (str) => "delete",
      Cell: ({ original, index }) => (
        <div>
          <span
            onClick={() => {
              onEditBrandInfo(index, original);
              //  this.setState({
              //    modalEdit: true,
              //    index: index,
              //    dealerId: original._id,
              //  });
            }}
            style={{ cursor: "pointer" }}
            title="Edit Brand Info"
          >
            <i
              className="bi bi-pencil-fill"
              style={{
                width: 35,
                fontSize: 20,
                padding: 5,
                color: "#1890ff",
              }}
            ></i>
          </span>
          {/* <span style={{ cursor: "pointer" }} title="View StaffMember info"><i className="fa fa-eye" style={{ width: 35, fontSize: 20, padding: 5, color: '#1890ff' }}></i></span> */}
        </div>
      ),
      style: {
        display:"flex",
          justifyContent:"center",
          alignItems:"center",
        fontWeight: "600",
      },
      sortable: false,
    });
    return (
      <Fragment>
        <ReactTable
          manual
          data={myData}
          columns={columns}
          className={myClass}
          loading={loading}
          pages={totalRecords}
          page={page}
          pageSize={pageSize || 10}
          showPagination={pagination}
          onPageChange={(pageIndex) => onChangePage(pageIndex)}
          onPageSizeChange={(pageSize, pageIndex) =>
            // //console.log({ pageSize, pageIndex })
            onChangePageSize(pageSize)
          }
          showPagination={pagination}
          onFetchData={(state, instance) => console.log({ state, instance })}
          SubComponent={(v) => {
            console.log({ v });
            var original = v.original;
            const productInfoProps = {
              pictursList: original.pictursList,
              productDescription: original.description,
              info: original,
              isEdit: true,
              isView: true,
              categoryList: categoryList,
              brandsList: brandsList,
              pdfFileUrl: original.pdfFileUrl,
            };
            return (
              <>
                <ProductInfo {...productInfoProps} />
                <div
                  className="card border-0"
                  style={{
                    fontWeight: 600,
                    marginInline: "20px",
                    marginBottom: "30px",
                    boxShadow: "1px 5px 24px 0 rgba(68, 102, 242, .05)",
                    paddingInline: "25px"
                  }}
                >
                  <div className="card-title fs-5 f-w-6">Description</div>
                  {/* </div> */}
                  <div className="card-body">
                    <div
                      id="view-inner-html"
                      dangerouslySetInnerHTML={{
                        __html: original.description,
                      }}
                    ></div>
                  </div>
                </div>
              </>
            );
            // <EmailBodyInfo index={v.row._index} myData={myData} />
          }}
        />
        {/* <ToastContainer /> */}
      </Fragment>
    );
  }
}

export default Datatable;
